<template>
  <main class="content">
    <div class="main-content">
      <h2>GeneralTerms</h2>
      <p>This is the main section of the page.</p>
    </div>
    <div class="side-content">
      <h2>Sidebar</h2>
      <p>Additional content goes here.</p>
    </div>
  </main>
</template>

<script>
export default {
  name: 'GeneralTerms',
};
</script>

<style scoped></style>